<template>
    <div>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Combine Assessmnet Type</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Academic Year</b></p>
                        <v-autocomplete @change="getCombineassesmentType()" color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Assessment Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="assessment_type" :items="assessment_type_list" item-text="ass_type_name" item-value="id" label="Assesment Type" outlined persistent-hint hint="Please Select Assesment Type" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Combine Assessment Type</b></p>
                        <v-autocomplete color="#0F2027" multiple dense rounded required v-model="combine_assessment_type" :items="assessment_type_list" item-text="ass_type_name" item-value="id" label="Combine Assessment Type" outlined persistent-hint hint="Please Select Combine Assessment Type" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Semester</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="sem" :items="sem_list" item-text="sem_name" item-value="id" label="Semester" outlined persistent-hint hint="Please Select Semester" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Converted To</b></p>
                        <v-text-field v-model="converted_to" type="number" label="Converted To" dense outlined rounded> </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                    <v-btn class="button mt-10" v-if="ay && sem && assessment_type && converted_to && combine_assessment_type!=''" @click="save()" :loading="loader">Save</v-btn>
                    </v-col>
                </v-row>
                </v-card>
                <v-card class="box" v-if="combine_assessment_type_list!=''">
                    <v-data-table :headers="headers" class="elevation-1 mytable" dense :items="combine_assessment_type_list">
                        <!-- delete -->
                        <template v-slot:[`item.delete`]="{ item }">
                            <div>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size" color="red" @click="deletedialog(item)">mdi-trash-can</v-icon>
                                </v-avatar>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
                <v-dialog v-model="dialog_delete_option1" persistent max-width="500px">
                <v-card>
                    <v-container>
                    <v-card class="box">
                        <input type="hidden" v-model="deleteItem_opt1.delete_id1" />
                        <strong>Are you sure you want Delete this fee???</strong>
                        <v-row justify="center">
                        <v-btn class="button" text @click="dialog_delete_option1 = false">No</v-btn>
                        <v-btn class="button" text @click="deleteCombineAssementType()">Yes</v-btn>
                        </v-row>
                    </v-card>
                    </v-container>
                </v-card>
            </v-dialog>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            delete_attach_load: false,
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_list: [],
            assessment_type_list: [],
            ay: "",
            assessment_type:null,
            combine_assessment_type:[],
            sem_list:[],
            sem:null,
            combine_assessment_type_list:[],
            converted_to:null,
            combineasstype_final:[],
            dialog_delete_option1:false,
            deleteItem_opt1: {
                delete_id1: "",
            },
            headers: [
                { text: "Academic Year", value: "academicyear" },
                { text: "Semester", value: "semester" },
                { text: "Converted", value: "convertedto" },
                { text: "Combine Assessment Type", value: "assessmentcombine" },
                { text: "Assessment Type", value: "assessmentcombinedfrom" },
                { text: "Delete", value: "delete" },
            ],
        }),
        methods: {
            deleteCombineAssementType(){
                const data ={
                    id : this.deleteItem_opt1.delete_id1
                }
                axios
                    .post("/Examination/deleteCombineAssementType",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Deleted Successfully...");
                            this.dialog_delete_option1 = false
                            this.getCombineassesmentType()
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {

                    });
            },
            deletedialog(item){
                this.dialog_delete_option1 = true;
                this.deleteItem_opt1.delete_id1 = item.id;
            },
            save(){
                for(var i=0;i<this.combine_assessment_type.length;i++){
                    //if(this.combine_assessment_type[i] != this.assessment_type){
                        this.combineasstype_final.push(this.combine_assessment_type[i])
                   // }
                }
                const data={
                     ay:this.ay,
                     sem:this.sem,
                     assessment_type:this.assessment_type,
                     combine_assessment_type:this.combineasstype_final,
                     converted_to:this.converted_to
                }
                axios
                    .post("/Examination/saveCombineAssessmentType",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Saved Successfully...");
                            this.getCombineassesmentType()
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                     this.ay = "",
                     this.sem = null,
                     this.assessment_type = null,
                     this.combineasstype_final = [],
                     this.combine_assessment_type = [],
                     this.converted_to  = []
                    });
            },
          
            onLoad() {
                axios
                    .post("/Examination/getassesmentType")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.ay_list = res.data.ay_list
                            this.assessment_type_list = res.data.assessment_type_list
                            this.sem_list = res.data.sem_list
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {});
            },
            getCombineassesmentType(){
                const data ={
                    ay:this.ay
                }
                axios
                    .post("/Examination/getCombineassesmentType",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.combine_assessment_type_list = res.data.combine_assessment_type_list
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {});
            },
           
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
   
</style>
